import ModelEntity from "../../../model2/model-entity"

// One row of an Entity Selector list, whatever tab produced it.
//
// The three list tabs (Task/Recent, Document, Meeting) feed the SAME glist, so
// they have to agree on a row shape -- and their sources do not: a task keeps
// its name in `title`, a document and a meeting in `name`, and each keeps its
// "when" somewhere else again. A glist reads a column value as
// `_.get(model, fieldId)`, so that normalisation has to happen before the row
// goes in, never inside a cell.
//
// `entity` is the untouched source model: the icon reads its type (and a task's
// taskTypeId) off it, and the picked MentionOption carries it through as `data`,
// which is what the optimistic related-item row is built from.
export default class EntitySelectorItem {

    public id           : ID
    public entity       : ModelEntity
    public title        : string
    public date         : Moment | null
    public projectId    : ID | null

    constructor(data: {
        entity      : ModelEntity
        title       : string
        date?       : Moment | null
        projectId?  : ID | null
    }) {
        this.id         = data.entity.id
        this.entity     = data.entity
        this.title      = data.title
        this.date       = data.date     || null
        this.projectId  = data.projectId || null
    }

    // Collection<Model> requires it; nothing serialises a row.
    toJSON() {
        return {
            id      : this.id,
            title   : this.title
        }
    }
}
